export const DEG = Math.PI / 180;
export const deg2rad = (d: number): number => d * DEG;
export const rad2deg = (r: number): number => r / DEG;
